<template>
  <div class="aspect-3/4 w-full flex items-center justify-center border-1 border-neutral-100">
      <NuxtLink :to="productPageUrl" @click="emit('product-selected', { product })">
        <NuxtImg :src="product.images[0].src" width="400" provider="imgproxy" class="object-cover m-auto p-5" />
      </NuxtLink>
  </div>
  <div class="text-center mb-5 pt-2">
    <p class="uppercase">{{ product.title }}</p>
    <p>{{ useFormatMoney(product.price)  }}</p>
  </div>
</template>

<script setup lang="ts">
import type {Product} from "~/models/product";
const { product, handle } = defineProps<{
  product: Product,
  handle: string,
}>()

const productPageUrl = `/${handle}/${product.handle}`

const emit = defineEmits<{
  'product-selected': [Product]
}>()

</script>